import { useState } from "react";
import { ArrowsClockwise, ShieldCheck } from "@phosphor-icons/react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { usePortfolio } from "@/context/ProfileContext";
import { PlaidLauncher, PLAID_START_EVENT } from "@/components/PlaidConnect";
import { api, errMsg } from "@/lib/api";
import { usd } from "@/lib/format";

export function TspPlaidLauncher() {
  const { loadDash } = usePortfolio();
  return <PlaidLauncher onLinked={loadDash} />;
}

export function TspAutoSync({ onClose }) {
  const { dash, loadDash } = usePortfolio();
  const [busy, setBusy] = useState(false);
  const linked = dash?.meta?.plaid_linked;
  const syncNow = async () => {
    setBusy(true);
    try { const r = await api.post("/sync"); await loadDash(); toast.success(`Synced. TSP ${usd(r.data.totals.tsp)}`); onClose(); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  const connect = () => { onClose(); setTimeout(() => window.dispatchEvent(new Event(PLAID_START_EVENT)), 250); };
  return (
    <div className="rounded-2xl border border-cyan-200 dark:border-cyan-900 bg-cyan-50/60 dark:bg-cyan-950/30 p-4 space-y-2" data-testid="tsp-auto-sync">
      <p className="text-sm font-semibold">Option 1: Sign in to TSP.gov and sync automatically</p>
      {linked ? (
        <>
          <p className="text-sm text-muted-foreground" data-testid="tsp-auto-sync-status">Automatic sync is on{dash?.meta?.last_sync ? `, last synced ${new Date(dash.meta.last_sync).toLocaleString()}` : ""}. Your shares update by themselves when the TSP reports changes.</p>
          <div className="flex flex-wrap gap-2">
            <Button size="sm" className="rounded-full" onClick={syncNow} disabled={busy} data-testid="tsp-auto-sync-now-button"><ArrowsClockwise size={14} className="mr-1.5" />{busy ? "Syncing..." : "Sync now"}</Button>
            <Button size="sm" variant="outline" className="rounded-full" onClick={connect} data-testid="tsp-auto-sync-reconnect-button">Reconnect TSP.gov</Button>
          </div>
        </>
      ) : (
        <>
          <p className="text-sm text-muted-foreground">Search for "Thrift Savings Plan", sign in with your TSP.gov username and password, then enter the one-time code TSP sends you. Your shares and balances then sync on their own.</p>
          <Button size="sm" className="rounded-full" onClick={connect} data-testid="tsp-auto-sync-connect-button"><ArrowsClockwise size={14} className="mr-1.5" />Sign in to TSP.gov &amp; sync automatically</Button>
        </>
      )}
      <p className="flex gap-2 text-xs text-muted-foreground"><ShieldCheck size={16} className="text-emerald-600 shrink-0" />You sign in inside Plaid's secure window, a service used by many financial apps. PillarWealth never sees or stores your TSP password and can't make changes to your TSP account.</p>
    </div>
  );
}
